const mockAgent = {
  firstName: "(Your Lender's",
  lastName: 'Name Here)',
  photoUri: 'assets/homes/img/mike_smith.png',
  nmls: 1000000
}

export default mockAgent
